import { render, staticRenderFns } from "./doctorAdd.vue?vue&type=template&id=1cc3b084&scoped=true"
import script from "./doctorAdd.vue?vue&type=script&lang=js"
export * from "./doctorAdd.vue?vue&type=script&lang=js"
import style0 from "./doctorAdd.vue?vue&type=style&index=0&id=1cc3b084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc3b084",
  null
  
)

export default component.exports